import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const completedReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.FIELD_COMPLETED:
			return {
				...state,
				[action.fieldName]: true,
			}

		case actionTypes.FIELD_IN_EDIT:
			return {
				...state,
				[action.fieldName]: false,
			}

		case actionTypes.CLEAR_BOOK_FIELDS:
			return {}

		default:
			return state
	}
}

export const fieldInEditReducer = (state = null, action) => {
	switch (action.type) {
		case actionTypes.FIELD_COMPLETED:
			if (action.fieldName === state) return null
			return state

		case actionTypes.FIELD_IN_EDIT:
			return action.fieldName

		case actionTypes.CLEAR_BOOK_FIELDS:
			return null

		default:
			return state
	}
}

export default combineReducers({
	completed: completedReducer,
	fieldInEdit: fieldInEditReducer,
})

// *** Selectors

export const getCompletedFields = state => state.completed
export const getFieldInEdit = state => state.fieldInEdit
